import Swiper from "swiper/dist/js/swiper.js";

export default {
    init() {

        /* NEWS SLIDER */
        const news_sliders = document.querySelectorAll('.home-news .swiper-container');

        if (news_sliders !== null) {
            for (let index = 0; index < news_sliders.length; index++) {
                const scrollbar = news_sliders[index].querySelector('.swiper-scrollbar');
                let swiper = new Swiper(news_sliders[index], {
                    speed: 400,
                    slidesPerView: 3.25,
                    spaceBetween: 24,
                    touchRatio: 0,
                    loop: false,
                    navigation: {
                        nextEl: news_sliders[index].previousElementSibling.lastElementChild.querySelector('.swiper-button-next'),
                        prevEl: news_sliders[index].previousElementSibling.lastElementChild.querySelector('.swiper-button-prev'),
                    },
                    scrollbar: {
                        el: news_sliders[index].querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    mousewheel: true,
                    breakpoints: {
                        767: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                            touchRatio: 1
                        },
                        1025: {
                            slidesPerView: 2,
                        }
                    },
                });
            }
        }

        // banner flip
        const bannerWrapper = document.querySelector(".hero-banner .row");

        const flipBanner = () => {
            if (window.innerWidth < 767) {
                if (!bannerWrapper.classList.contains("moved")) {
                    bannerWrapper.classList.add("moved");
                    const image = bannerWrapper.lastElementChild;
                    bannerWrapper.insertAdjacentElement("afterbegin", image);
                }
            } else {
                if (bannerWrapper.classList.contains("moved")) {
                    bannerWrapper.classList.remove("moved");
                    const image = bannerWrapper.firstElementChild;
                    bannerWrapper.insertAdjacentElement("beforeend", image);
                }
            }
        }

        flipBanner();

        window.addEventListener("resize", flipBanner);

        // about flip
        const aboutWrapper = document.querySelector(".home-about .row");

        const flipAbout = () => {
            if (window.innerWidth < 767) {
                if (!aboutWrapper.classList.contains("moved")) {
                    aboutWrapper.classList.add("moved");
                    const image = aboutWrapper.lastElementChild;
                    aboutWrapper.insertAdjacentElement("afterbegin", image);
                }
            } else {
                if (aboutWrapper.classList.contains("moved")) {
                    aboutWrapper.classList.remove("moved");
                    const image = aboutWrapper.firstElementChild;
                    aboutWrapper.insertAdjacentElement("beforeend", image);
                }
            }
        }

        if (aboutWrapper) {
            flipAbout();
        }

        window.addEventListener("resize", flipAbout);

        // Banner Video
        const video = document.querySelector('.hero-banner video');
        if (video) {
            const playBtn = document.querySelector('.hero-banner .banner-play-btn');
            if (playBtn) {
                const text = playBtn.querySelector('span');
                playBtn.addEventListener('click', () => {
                    if (playBtn.classList.contains('paused')) {
                        playBtn.classList.remove('paused');
                        playBtn.setAttribute('aria-pressed', true);
                        if (text) {
                            text.innerHTML = "Play Video";
                        }
                        video.play();
                    } else {
                        playBtn.classList.add('paused');
                        playBtn.setAttribute('aria-pressed', false);
                        if (text) {
                            text.innerHTML = "Pause Video";
                        }
                        video.pause();
                    }
                })
            }
        }

        // Map section
        const mapSection = document.querySelector('#map-section');
        if (mapSection) {
            const statesList = mapSection.querySelector('.states-list');
            const stateListItems = statesList.querySelectorAll('li');
            const stateMap = mapSection.querySelector('.interactive-map svg');
            if (stateListItems && stateListItems.length > 0 && stateMap) {
                for (let i = 0; i < stateListItems.length; i++) {
                    const activeItem = stateListItems[i];
                    const toggle = activeItem.querySelector('h3 button');
                    const state = toggle.getAttribute('data-state');
                    const description = activeItem.querySelector('.description');
                    const stateId = '#' + state + '-state';
                    const stateShape = stateMap.querySelector(stateId);

                    toggle.addEventListener('mouseenter', () => {
                        if (!activeItem.classList.contains('active')) {
                            for (let n = 0; n < stateListItems.length; n++) {
                                const otherItem = stateListItems[n];
                                const otherToggle = otherItem.querySelector('h3 button');
                                const otherState = otherToggle.getAttribute('data-state');
                                const otherDescription = activeItem.querySelector('.description');
                                if (otherItem !== activeItem) {
                                    otherItem.classList.remove('active');
                                    otherToggle.setAttribute('aria-expanded', false);
                                    if (otherDescription) {
                                        otherDescription.setAttribute('hidden', '');
                                    }

                                    const otherStateId = '#' + otherState + '-state';
                                    const otherStateShape = stateMap.querySelector(otherStateId);
                                    otherStateShape.setAttribute('aria-expanded', false);
                                }
                            }
                            activeItem.classList.add('active');
                            toggle.setAttribute('aria-expanded', true);
                            if (description) {
                                description.removeAttribute('hidden');
                            }

                            stateShape.setAttribute('aria-expanded', true);
                        }
                    });

                    toggle.addEventListener('keyup', (e) => {
                        if(e.key === 'Enter') {
                            if (!activeItem.classList.contains('active')) {
                                for (let n = 0; n < stateListItems.length; n++) {
                                    const otherItem = stateListItems[n];
                                    const otherToggle = otherItem.querySelector('h3 button');
                                    const otherState = otherToggle.getAttribute('data-state');
                                    const otherDescription = activeItem.querySelector('.description');
                                    if (otherItem !== activeItem) {
                                        otherItem.classList.remove('active');
                                        otherToggle.setAttribute('aria-expanded', false);
                                        if (otherDescription) {
                                            otherDescription.setAttribute('hidden', '');
                                        }
    
                                        const otherStateId = '#' + otherState + '-state';
                                        const otherStateShape = stateMap.querySelector(otherStateId);
                                        otherStateShape.setAttribute('aria-expanded', false);
                                    }
                                }
                                activeItem.classList.add('active');
                                toggle.setAttribute('aria-expanded', true);
                                if (description) {
                                    description.removeAttribute('hidden');
                                }
    
                                stateShape.setAttribute('aria-expanded', true);
                            }
                        }
                    });

                    stateShape.addEventListener('mouseenter', () => {
                        for (let n = 0; n < stateListItems.length; n++) {
                            const otherItem = stateListItems[n];
                            const otherToggle = otherItem.querySelector('h3 button');
                            const otherState = otherToggle.getAttribute('data-state');
                            const otherDescription = activeItem.querySelector('.description');
                            if (otherItem !== activeItem) {
                                otherItem.classList.remove('active');
                                otherToggle.setAttribute('aria-expanded', false);
                                if (otherDescription) {
                                    otherDescription.setAttribute('hidden', '');
                                }

                                const otherStateId = '#' + otherState + '-state';
                                const otherStateShape = stateMap.querySelector(otherStateId);
                                otherStateShape.setAttribute('aria-expanded', false);
                            }
                        }

                        activeItem.classList.add('active');
                        toggle.setAttribute('aria-expanded', true);
                        if (description) {
                            description.removeAttribute('hidden');
                        }

                        stateShape.setAttribute('aria-expanded', true);
                    })
                }
            }
        }

        // Nav Scroll background
        window.addEventListener('scroll', function () {
            const scrollY = window.scrollY; // Vertical scroll position
            const scrollX = window.scrollX; // Horizontal scroll position
            const header = document.querySelector('header.header');

            if (header) {
                if (scrollY > 10) {
                    header.classList.add('scrolling');
                } else {
                    header.classList.remove('scrolling');
                }
            }
        });
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
